import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=312ab74b&scoped=true"
var script = {}
import style0 from "./notice.vue?vue&type=style&index=0&id=312ab74b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312ab74b",
  null
  
)

export default component.exports